export default __webpack_public_path__ + "static/media/nightIcon.8667cb91.svg";